<template>
	<regularModal
		:appendToBody="true"
		:noBottomPadding="true"
		top="5vh"
		width="60%"
		@close="
			() => {
				showScreenshotModal = false;
			}
		"
		:visible="showScreenshotModal"
	>
		<el-tabs style="margin-top: 40px" v-model="activeTab">
			<el-tab-pane
				:key="index"
				v-for="(screens, index) in screensPerChain"
				:label="'Data ' + index"
				:name="index.toString()"
			>
				<div class="tabBody">
					<h3 style="text-align: center" v-if="screens.length">AI Agent - Browser View</h3>
					<el-divider></el-divider>
					<el-carousel
						:loop="false"
						style="height: 500px"
						ref="screenShotViewer"
						:autoplay="false"
						:interval="5000"
						arrow="always"
					>
						<el-carousel-item v-for="(screen, i) in screens" :key="screen">
							<h3>View {{ i }}</h3>
							<el-divider></el-divider>
							<el-image style="display: block" :src="screen">
								<div slot="error" class="image-slot">
									<p>Failed or expired</p>
								</div>
								<div slot="placeholder" class="image-slot">
									<i class="el-icon-picture-outline"></i>
									<br />
									Loading...
								</div>
							</el-image>
						</el-carousel-item>
					</el-carousel>
				</div>
			</el-tab-pane>
		</el-tabs>
	</regularModal>
</template>

<script>
import regularModal from "./regularModal.vue";
export default {
	components: {
		regularModal,
	},
	data() {
		return {
			screensPerChain: [],
			showScreenshotModal: false,
			activeTab: "0",
		};
	},
	methods: {
		launch() {
			this.showScreenshotModal = true;
		},
		clearData() {
			this.showScreenshotModal = false;
			this.screensPerChain = [];
		},
		addScreen(screen, index) {
			if (!this.screensPerChain[index]) {
				this.screensPerChain.push([]);
			}
			this.screensPerChain[index].push(screen);
			if (this.screensPerChain[index].length === 1) {
				this.showScreenshotModal = true;
			}
			if (this.screensPerChain[index].length > 1) {
				setTimeout(() => {
					if (this.showScreenshotModal && this.$refs.screenShotViewer) {
						this.$refs.screenShotViewer[index]?.setActiveItem(this.screensPerChain[index].length - 1);
					}
				}, 500);
			}
		},
	},
};
</script>

<style>
.el-image {
	width: 450px;
	margin: auto;
	display: block;
}

.image-slot {
	text-align: center;
	margin-top: 40%;
}
</style>
